/**
 * Safety-net polling intervals for React Query.
 *
 * Socket.IO is the primary real-time mechanism. These intervals are fallbacks
 * that ensure data stays fresh even if the socket is disconnected.
 */

/** Core entities that change frequently: projects, POs, shipments, orders, comms, dashboard. */
export const POLL_NORMAL = 60_000

/** Reference data that changes infrequently: staff, manufacturers, contacts, products. */
export const POLL_SLOW = 120_000

/** A message the AI is still analyzing: its result should appear within seconds. */
export const POLL_ANALYSIS = 5_000
